import { render, staticRenderFns } from "./footballPrint.vue?vue&type=template&id=3dec3184"
import script from "./footballPrint.vue?vue&type=script&lang=js"
export * from "./footballPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports